// extracted by mini-css-extract-plugin
module.exports = {"label":"component_label__3FsdT","btnText":"component_btnText__1qgZn","img":"component_img__3yeqt"};